module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// const { console } = require('globalthis/implementation');

// Payment Details Confirm List
(function (fox, $) {
  "use strict";

  fox.registerWidget(
    "PaymentDetailsConfirmList",
    {
      configure: function () {
        this.registerOptions("", {
          template: "payment_details_confirm_list",
          "embed.container": "#paydet-confirm-container",
          autoRender: false,
          manualRender: true,
          paymentDetailsPage: "payment-details",
          clientId: null,
          widgets: {
            paymentDetailsLoad: {
              widget: "Api",
              method: "model.profile.getPredefinedPaymentData",
              handleWom: {
                paymentDataLoadSuccess: {
                  event: "success",
                  widget: "@this",
                  callback: "@parent:paymentDetailsLoadSuccess",
                },
                paymentDataLoadFailure: {
                  event: ["error", "failure"],
                  widget: "@this",
                  callback: "@parent:paymentDetailsLoadFailure",
                },
              },
            },
            paymentDetailsFields: {
              widget: "Account_PaymentDetailsFields",
            },
            paymentDetailsConfirm: {
              widget: "Api",
              method: "model.profile.confirmPaymentData",
            },
            confirmError: {
              widget: "Widget",
              autoRender: false,
              manualRender: true,
              container: ".error-wrap",
              template: "payment_details_confirm_error",
            },
          },
          handleDom: {
            btnEdit: {
              event: "click",
              target: "#btn-edit",
              callback: function () {
                fox.site.gotoPage(this.getOption("paymentDetailsPage"));
              },
            },
            btnConfirm: {
              event: "click",
              target: "#btn-confirm",
              callback: "sendConfirm",
            },
          },
        });

        this.callParent("configure", arguments);
      },

      running: function () {
        this.callParent("running", arguments);

        this.getPaymentDetails();
      },

      activate: function (argument) {
        this.callParent("activate", arguments);

        this.hasRequiredFields = false;

        this.getPaymentDetails();
      },

      deactivate: function (argument) {
        this.callParent("deactivate", arguments);

        this.hasRequiredFields = false;
      },

      prepareEmbeddedWidgets() {
        this._bindData = {
          dac7Form: 0,
          dac7_type: "",
        };

        this.bindTemplateVariables(this._bindData, ["dac7Form", "dac7_type"]);
      },

      getPaymentDetails: function () {
        if (fox.isEmpty(this.getOption("clientId"))) {
          this.setClient();
        }

        this.paymentDetailsLoad();
      },

      setClient: function (clientId) {
        this.setOption(
          "clientId",
          clientId || fox.site.member.getObjectValue("id")
        );
      },

      paymentDetailsLoad: function () {
        var clientId = this.getOption("clientId");

        if (clientId && fox.isNumeric(parseInt(clientId))) {
          this.wom1("#paymentDetailsLoad").send(
            {
              clientId: clientId,
            },
            false
          );
        }
      },

      paymentDetailsLoadSuccess: function (res) {
        if (!res.answer.status || res.answer.response === false) {
          return;
        }

        var vals = res.answer.response;
        this.setTemplateOptions({ paymentMethod: vals.paymentMethod });
        this.render();
        this.prepareDac7FormVals(vals);
        this.switchPaymentDetailsFields(vals);
      },

      paymentDetailsLoadFailure: function (res) {
        // console.log('payment data is not loaded');
      },

      prepareDac7FormVals: function (vals) {
        vals["firstNameDac7"] = vals["firstName"];
        vals["lastNameDac7"] = vals["lastName"];
        vals["birthdateDac7"] = vals["birthdate"];
        vals["addressCountry"] = vals["country"];
        vals["addressCity"] = vals["city"];
        vals["zipCodeAddress"] = vals["zipCode"];
        vals["businessName"] =
          vals.paymentMethod === 4 ? vals["payableTo"] : vals["beneficiary"];

        var fields = this.wom1("#paymentDetailsFields").getFormFields(
          vals.paymentMethod,
          vals.country,
          vals.legalType
        );

        this._bindData.dac7Form = fields.indexOf("dac7Form") != -1 ? 1 : 0;
        this._bindData.dac7_type = [undefined, "0", "Individual", ""].includes(
          vals.legalType
        )
          ? "individual"
          : "business";
      },

      switchPaymentDetailsFields: function (vals) {
        var paymentDetailsFields = this.wom1("#paymentDetailsFields");
        var fields = paymentDetailsFields.getFormFields(
          vals.paymentMethod,
          vals.country,
          vals.legalType
        );
        var domElement = this.element || this.fragment;
        var notRequiredFields = ["middleName", "vat"];

        fields = fields.filter(function (v) {
          return (
            !notRequiredFields.includes(v) ||
            (notRequiredFields.includes(v) && vals[v] !== "")
          );
        });

        $(domElement).find("[data-row]").hide();

        $(domElement)
          .find('[data-defrow="paymentMethod"] .value-block')
          .html(paymentDetailsFields.getPmTitle()[vals.paymentMethod]);

        fox.each(
          fields,
          function (field) {
            var fieldDom = $(domElement).find('[data-row="' + field + '"]'),
              fieldValueLabel = "";

            if (
              fox.isEmpty(vals[field]) &&
              !notRequiredFields.includes(field) &&
              field !== "dac7Form"
            ) {
              this.hasRequiredFields = true;
            }

            switch (field) {
              case "legalType":
              case "accountType":
                if (
                  vals.paymentMethod === 4 &&
                  vals.legalType === "Individual"
                ) {
                  fieldValueLabel = "Personal";
                } else {
                  fieldValueLabel =
                    paymentDetailsFields.getPmFieldsValuesLabel(field)[
                      vals[field]
                    ];
                }
                break;
              case "ownershipDocument":
                vals.ownershipDocument =
                  vals.ownershipDocument === "0" ||
                  fox.isEmpty(vals.ownershipDocument)
                    ? ""
                    : vals.ownershipDocument;
                break;
              case "paxumConfirmed":
                vals.paxumConfirmed =
                  vals.paxumConfirmed !== "1" ? "" : "confirmed";
                break;
            }
            vals[field] =
              fox.isEmpty(vals[field]) && !notRequiredFields.includes(field)
                ? '<span class="required">required<span>'
                : vals[field];
            fieldDom
              .find(".value-block")
              .html(
                fox.isEmpty(fieldValueLabel) ? vals[field] : fieldValueLabel
              );
            fieldDom.show();
          },
          this
        );
      },

      sendConfirm: function () {
        var clientId = this.getOption("clientId"),
          api = this.rwom1("#paymentDetailsConfirm");

        if (this.hasRequiredFields) {
          this.paymentDetailsConfirmFailure();
          return;
        }

        if (clientId && fox.isNumeric(parseInt(clientId))) {
          this.togglePreloader(true);

          api
            .psend({ clientId: clientId })
            .then(
              function (resp) {
                var data = resp.params.answer.response;
                if (data === true) {
                  this.paymentDetailsConfirmSuccess();
                } else {
                  this.paymentDetailsConfirmFailure();
                }
              }.bind(this)
            )
            .catch(
              function (err) {
                this.paymentDetailsConfirmFailure();
              }.bind(this)
            )
            .finally(
              function () {
                this.togglePreloader();
              }.bind(this)
            );
        }
      },

      paymentDetailsConfirmSuccess: function () {
        fox.site.gotoPage("payment-details");
      },

      paymentDetailsConfirmFailure: function () {
        this.showError();
        this.disableConfirmBtn();
      },

      togglePreloader: function (state) {
        var btn = this.dom1("#btn-confirm");

        if (!btn) {
          return;
        }

        fox.dom[state ? "addClass" : "removeClass"]("spin", btn);
      },

      disableConfirmBtn: function () {
        var btn = this.dom1("#btn-confirm");

        if (!btn) {
          return;
        }

        btn.disabled = true;
      },

      showError: function () {
        this.rwom1("#confirmError").render();
      },
    },
    "Widget"
  );
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/sitepage/paymentDetailsConfirm/paymentDetailsConfirmList.js
// module id = 352
// module chunks = 2